var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"app-navigation--secondary"},[_c('NavItems',{attrs:{"data":_vm.data,"showIcons":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }